import { store } from '../../../configureStore';
import orm from '../../../orm';

const DEBUG = true;
const debugLog = (msg: string) => {
  if (DEBUG) {
    console.log(msg);
  }
};

export const getPanoNavNodeIdFromPanoScene = (newPanoScene: string) => {
  debugLog('getPanoNavNodeIdFromPanoScene - function START');
  // debugLog('getPanoNavNodeIdFromPanoScene - received stringified PanoScene = ' + JSON.stringify(JSON.parse(newPanoScene), null, 2));
  const sceneName = JSON.parse(newPanoScene).name;
  const sceneTitle = JSON.parse(newPanoScene).title;

  const session = orm.session(store.getState().orm);
  const { NavNode, Pano } = session;

  const allNavNodesArray = NavNode.all().toRefArray();
  debugLog('getPanoNavNodeIdFromPanoScene - number of pano navNodes :' + (allNavNodesArray.filter((node: any) => node.type === 'pano').length));

  let allPanoNavNodesArray: any[] = [];
  allNavNodesArray.forEach((navNode: any) => {
    if (navNode.type == 'pano') {
      allPanoNavNodesArray.push(navNode);
    }
  })

  let panoNavNodeCounter: number = allPanoNavNodesArray.length;
  let successPanoNavNodeCounter: number = 0;
  let panoNavNodeWithoutStartSceneCounter: number = 0;


  let navNodeForCurrentPanoScene: any = null;
  allPanoNavNodesArray.forEach((navNode: any) => {
    // // debugLog('getPanoNavNodeIdFromPanoScene - navNode.panoVersionStartSceneSlug :');
    // // debugLog(navNode.panoVersionStartSceneSlug);
    if (navNode.panoVersionStartSceneSlug !== null && navNode.panoVersionStartSceneSlug !== undefined &&
      navNode.panoVersionStartSceneSlug.trim().toLowerCase() === sceneName.trim().toLowerCase()) 
    {
      navNodeForCurrentPanoScene = navNode;
      debugLog('WE FOUND THE SCENE');
      debugLog(JSON.stringify(navNode.panoVersionStartSceneSlug, null, 2));
      // debugLog('navNode START ---------->');
      // debugLog(JSON.stringify(navNode, null, 2));
      // debugLog('navNode END ---------->');
      successPanoNavNodeCounter++;
    } else {
      // debugLog('WE DID NOT FIND THE SCENE :' + sceneName);
      if (navNode.panoVersionStartSceneSlug == null || navNode.panoVersionStartSceneSlug == undefined) {
        debugLog('getPanoNavNodeIdFromPanoScene - Pano WITHOUT a defined panoVersionStartSceneSlug !!!');
        panoNavNodeWithoutStartSceneCounter++;
      } else {
      }
    }
  });

  // debugLog('getPanoNavNodeIdFromPanoScene - ALL PANO NAV NODES - successPanoNavNodeCounter : ' + successPanoNavNodeCounter);
  // debugLog('getPanoNavNodeIdFromPanoScene - panoNavNodeCounter : ' + panoNavNodeCounter);
  // debugLog('getPanoNavNodeIdFromPanoScene - panoNavNodeWithoutStartSceneCounter : ' + panoNavNodeWithoutStartSceneCounter);


  let currentPanoNavNodeId = null;
  if (navNodeForCurrentPanoScene != null) {
    currentPanoNavNodeId = navNodeForCurrentPanoScene["id"];
  }

  debugLog('getPanoNavNodeIdFromPanoScene - Function END');
  return currentPanoNavNodeId;
}